<script>
import { mapGetters, mapActions } from 'vuex'
import capitalize from 'lodash/capitalize'
import PublishingInformation from './tabs/publishing-information.vue'
import PublishingAdded from './tabs/publishing-added.vue'
import PublishingUpdated from './tabs/publishing-updated.vue'
import PublishingDeleted from './tabs/publishing-deleted.vue'
export default {
  name: 'PublishingDetails',
  components: {
    PublishingInformation,
    PublishingAdded,
    PublishingUpdated,
    PublishingDeleted,
  },
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      activeTab: '',
      loading: true,
      publishing: {},
    }
  },
  computed: {
    ...mapGetters('me', [
      'providerPublishInternal',
      'providerPublishExternal',
      'providerPublishInternalDecline',
      'providerPublishedProductNew',
      'providerPublishedProductUpdated',
      'providerPublishedProductDeleted',
    ]),
    readyForReview() {
      return this.publishing.status === 'completed' && !this.publishing.externalStatus
    },
    tabs() {
      const { publishing } = this
      const tabsList = []
      if (this.providerPublishInternal) {
        tabsList.push({
          label: 'Information',
          name: 'information',
        })
      }
      if (
        publishing.objects_added > 0 &&
        this.readyForReview &&
        this.providerPublishedProductNew
      ) {
        tabsList.push({
          label: 'Products Added',
          name: 'added',
        })
      }
      if (
        publishing.objects_updated > 0 &&
        this.readyForReview &&
        this.providerPublishedProductUpdated
      ) {
        tabsList.push({
          label: 'Products Updated',
          name: 'updated',
        })
      }
      if (
        publishing.objects_deleted > 0 &&
        this.readyForReview &&
        this.providerPublishedProductDeleted
      ) {
        tabsList.push({
          label: 'Products Deleted',
          name: 'deleted',
        })
      }
      return tabsList
    },
    commands() {
      const commandsList = []
      if (this.providerPublishExternal) {
        commandsList.push({
          label: 'Approve',
          name: 'approve',
        })
      }
      if (this.providerPublishInternalDecline) {
        commandsList.push({
          label: 'Decline',
          name: 'decline',
        })
      }
      return commandsList
    },
    backRoute() {
      return {
        name: 'provider-details',
        params: {
          id: this.publishing.providerId,
          tab: 'publishing',
        },
      }
    },
  },
  async created() {
    this.activeTab = this.$route.params.tab || this.tabs[0].name
    const [error, succses] = await this.getInternalPublishing(this.id)

    if (error) {
      this.getErrorMessage(error, 'Publishing', 'ID', this.id)
    } else {
      this.publishing = succses
    }
    this.loading = false
  },
  methods: {
    ...mapActions('publishing', ['getInternalPublishing']),
    capitalize,
    onTabClick(newTab, prevTab) {
      if (newTab !== prevTab) {
        this.$router.push({
          name: 'publish-details',
          params: {
            id: this.id,
            tab: newTab,
          },
        })
      }
    },
    onMenuSelect(name) {
      this.$modal.show(`publishing-${name}`, {
        props: {
          publishing: this.publishing,
        },
      })
    },
  },
}
</script>

<template>
  <main-layout
    title="Catalogue Publish"
    :loading="loading"
    :back="backRoute"
    :error-message="errorMessageText"
  >
    <el-dropdown
      v-if="readyForReview && commands.length && !errorMessageText"
      slot="header"
      trigger="click"
      @command="onMenuSelect"
    >
      <dropdown-icon />
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="(command, index) in commands"
          :key="index"
          :command="command.name"
        >
          {{ command.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-tabs
      v-model="activeTab"
      :before-leave="onTabClick"
    >
      <el-tab-pane
        v-for="tab in tabs"
        :key="tab.name"
        :label="tab.label"
        :name="tab.name"
        lazy
      >
        <component
          :is="`Publishing${capitalize(tab.name)}`"
          v-if="activeTab === tab.name"
          :loading="loading"
          :publishing="publishing"
        />
      </el-tab-pane>
    </el-tabs>
  </main-layout>
</template>
